/*
 * @Description: '结局方案'页面所有路由
 * @Author: mike ma *
 * @Date: 2021-02-24 16:50:00
 * @LastEditTime: 2021-02-27 20:12:42
*/

export default [
    {
        path: 'solution',
        component: resolve => require(['@/views/solution'], resolve),
        name: 'Solution',
        meta: {
            nav: '解决方案'
        }
    }
      
]


// WEBPACK FOOTER //
// ./src/router/solution.js